import React, { useEffect, useState } from "react";
import { backendUrl } from "./backendUrl";
import "bulma/css/bulma.min.css";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<number>(1);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Detekcja szerokości ekranu
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 960);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleTabClick = (tabNumber: number) => {
    setActiveTab(tabNumber);
    setMobileMenuOpen(false);
  };

  return (
    <nav
      id="navbar"
      className="navbar is-fixed-top"
      role="navigation"
      aria-label="main navigation"
      style={{
        background: "white",
        borderBottom: isMobile ? "1px solid #e5e5e5" : undefined,
        zIndex: 101,
      }}
    >
      <div className="navbar-menu" style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%", padding: isMobile ? "0 8px" : undefined }}>
        <div className="navbar-start" style={{ flex: "0 0 auto" }}></div>

        <div className="navbar-start" style={{ width: isMobile ? "100%" : "75%", display: "flex", alignItems: "center", justifyContent: isMobile ? "space-between" : undefined }}>
          <div className="navbar-brand" style={{ display: "flex", alignItems: "center" }}>
            <a href="/">
              <img src={`${backendUrl}/img/W+Mlogo.svg`} style={{ height: '3rem', padding: '3px' }} alt="Logo" />
            </a>
          </div>
          {/* Hamburger na mobile */}
          {isMobile && (
            <button
              aria-label="menu"
              aria-expanded={mobileMenuOpen}
              onClick={() => setMobileMenuOpen((v) => !v)}
              style={{ background: "none", border: "none", padding: 0, marginLeft: 8, cursor: "pointer" }}
            >
              <span style={{ display: "block", width: 28, height: 4, background: "#005CA9", margin: "5px 0", borderRadius: 2 }}></span>
              <span style={{ display: "block", width: 28, height: 4, background: "#005CA9", margin: "5px 0", borderRadius: 2 }}></span>
              <span style={{ display: "block", width: 28, height: 4, background: "#005CA9", margin: "5px 0", borderRadius: 2 }}></span>
            </button>
          )}
          {/* Taby */}
          <div
            className="tabs is-boxed"
            style={{
              width: isMobile ? "100%" : "70%",
              marginLeft: isMobile ? 0 : 24,
              display: isMobile ? (mobileMenuOpen ? "block" : "none") : "block",
              position: isMobile ? "absolute" : undefined,
              top: isMobile ? 60 : undefined,
              left: 0,
              background: isMobile ? "white" : undefined,
              boxShadow: isMobile && mobileMenuOpen ? "0 4px 16px rgba(0,0,0,0.08)" : undefined,
              zIndex: isMobile ? 1001 : undefined,
              borderRadius: isMobile ? "0 0 12px 12px" : undefined,
              padding: isMobile ? "12px 0 8px 0" : undefined,
            }}
          >
            <ul className="is-justify-content-space-around">
              <li className={location.pathname === "/1" ? "is-active" : ""}>
                <Link to="/1">
                <div
                  onClick={() => handleTabClick(1)}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    color: location.pathname === "/1" ? "#005CA9" : "#B9B9BA",
                  }}
                >
                  <div style={{ justifyContent: "center" }}>
                    <img
                      src={
                        location.pathname === "/1"
                          ? `${backendUrl}/img/1.png`
                          : `${backendUrl}/img/1un.png`
                      }
                      alt="number"
                      style={{
                        width: "14px",
                        marginRight: "3px",
                      }}
                    ></img>
                    <span style={{ fontSize: "14px" }}>
                      Schließplan erstellen
                    </span>
                  </div>
                </div>
                </Link>
              </li>
              <li className={location.pathname === "/2" ? "is-active" : ""}>
                <Link to="/2">
                <div
                  onClick={() => handleTabClick(2)}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    color: location.pathname === "/2" ? "#005CA9" : "#B9B9BA",
                  }}
                >
                  <div>
                    <img
                      src={
                        location.pathname === "/2"
                          ? `${backendUrl}/img/2.png`
                          : `${backendUrl}/img/2un.png`
                      }
                      alt="number"
                      style={{
                        width: "14px",
                        marginRight: "3px",
                      }}
                    ></img>
                    <span style={{ fontSize: "14px" }}>Systemauswahl</span>
                  </div>
                </div>
                </Link>
              </li>
              <li className={location.pathname === "/3" ? "is-active" : ""}>
                <Link to="/3">
                <div
                  onClick={() => handleTabClick(3)}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    color: location.pathname === "/3" ? "#005CA9" : "#B9B9BA",
                  }}
                >
                  <div>
                    <img
                      src={
                        location.pathname === "/3"
                          ? `${backendUrl}/img/3.png`
                          : `${backendUrl}/img/3un.png`
                      }
                      alt="number"
                      style={{
                        width: "14px",
                        marginRight: "3px",
                      }}
                    ></img>
                    <span style={{ fontSize: "14px" }}>Zusammenfassung</span>
                  </div>
                </div>
                </Link>
              </li>
              <li className={location.pathname === "/4" ? "is-active" : ""}>
                <Link to="/4">
                <div
                  onClick={() => handleTabClick(4)}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    color: location.pathname === "/4" ? "#005CA9" : "#B9B9BA",
                  }}
                >
                  
                  <div>
                    <img
                      src={
                        location.pathname === "/4"
                          ? `${backendUrl}/img/4.png`
                          : `${backendUrl}/img/4un.png`
                      }
                      alt="number"
                      style={{
                        width: "14px",
                        marginRight: "3px",
                      }}
                    ></img>
                    <span style={{ fontSize: "14px" }}>
                      Bestellung
                    </span>
                  </div>
                </div>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
